import { render, staticRenderFns } from "./StartSection.vue?vue&type=template&id=7d19765e&scoped=true&"
import script from "./StartSection.vue?vue&type=script&lang=js&"
export * from "./StartSection.vue?vue&type=script&lang=js&"
import style0 from "./StartSection.vue?vue&type=style&index=0&id=7d19765e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d19765e",
  null
  
)

export default component.exports